import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreditCardValidators } from 'angular-cc-library';
import { APP_CONSTANT, AppConst } from 'src/app/core/_constants/app.constant';
import { showDuration } from 'src/app/core/_constants/helper';
import { ValidationService } from 'src/app/core/_services/common/validation.service';
import { OnlinePaymentComponent, fiveWordsValidator } from '../online-payment/online-payment.component';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import * as moment from 'moment';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';

declare var Runner: any;

export function cvcValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return { required: true }; // Value is required
    }
    const isValid = /^\d{3,4}$/.test(value); // Matches only 3-4 digits
    return isValid ? null : { invalidCVC: true }; // Return error if invalid
  };
}

@Component({
  selector: 'app-take-online-payment',
  templateUrl: './take-online-payment.component.html',
  styleUrls: ['./take-online-payment.component.scss']
})


export class TakeOnlinePaymentComponent implements OnInit, AfterViewInit {

  validationErrorMessage = APP_CONSTANT.VALIDATION;
  maxLength = AppConst.MAXLENGTH;
  public creditCardForm: FormGroup;
  public bankAccountForm: FormGroup;
  submitted: boolean = false;
  paymentOnline: any = 'credit';
  totalClientCount: number = 0;
  adminProfile: any;
  clientList: any[] = [];

  constructor(public dialogRef: MatDialogRef<OnlinePaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private storageService: LocalStorageProvider, private fb: FormBuilder, public validationService: ValidationService,
    private service: PagesService,
    private toastr: ToastrService,
    private loader: NgxUiLoaderService,) {
    this.adminProfile = this.storageService.getItem('CurrentUser')
  }


  fromClientPayment: boolean = false;
  ngOnInit(): void {
    this.creditCardForm = this.createForm();
    this.searchClient();
    if (this.data?.type === 'client') {
      this.fromClientPayment = true;
      this.creditCardForm.get('clientName').addValidators(Validators.required);
      this.creditCardForm.updateValueAndValidity();

      if (this.data?.email) {
        this.creditCardForm.patchValue({
          clientName: this.data.email,
        });
        this.creditCardForm.get('clientName').disable();

        if (this.data?.subNewData) {
          this.creditCardForm.patchValue({
            amount: Number(this.data?.subNewData.amount).toFixed(2),
          });
          this.creditCardForm.get('amount').disable();
        }
      } else {
        this.searchClient();
      }
    }
    if (this.adminProfile?.paymentGateway === 'RUNPAYMENTS') {
      this.runPay = true;
      this.creditCardForm.get('cardNumber').clearValidators();
      this.creditCardForm.get('cardCode').clearValidators();
      this.creditCardForm.updateValueAndValidity();
    }
  }

  searchClient() {
    this.creditCardForm.get('clientName')?.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      )
      .subscribe((res: any) => {
        this.getClientList(res);
      });
  }

  getClientList(searchString) {
    const data = {
      search: searchString,
      pageIndex: 1,
      limit: 10
    }
    this.loader.start();
    this.service.get(data, `${API_ROUTES.CLIENT.getClientList}`).pipe().subscribe((response: any) => {
      this.loader.stop();
      if (response.status) {
        this.clientList = response.data.list;
        this.totalClientCount = response.data.count;
      } else {
        this.totalClientCount = 0;
      }
    })
  }

  createForm() {
    return this.fb.group({
      clientName: [''],
      email: ['', [Validators.required, Validators.email, Validators.pattern(AppConst.EMAIL_PATTERN)]],
      phoneNumber: ['', Validators.required],
      amount: ['', Validators.required],
      holderName: ['', [Validators.required, fiveWordsValidator()]],
      cardNumber: ['', [Validators.required, CreditCardValidators.validateCCNumber]],
      expirationDate: ['', [Validators.required, CreditCardValidators.validateExpDate]],
      cardCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4), cvcValidator()]],
      notes: ['']
    })
  }

  get f() { return this.creditCardForm.controls; }


  close(value: Boolean) {
    this.dialogRef.close(value);
  }

  chargeSubmit() {
    this.submitted = true;
    if (this.paymentOnline == 'credit' && this.creditCardForm.valid) {
      let expDate = this.creditCardForm.value.expirationDate.split('/')[1].trim();
      expDate = expDate.length == 4 ? expDate : '20' + expDate
      let data;
      data = {
        clientName: this.creditCardForm.value.clientName,
        notes: this.creditCardForm.value.notes,
        email: this.creditCardForm.value.email,
        phoneNumber: this.creditCardForm.value.phoneNumber,
        amount: this.creditCardForm.value.amount,
        card_holder_name: this.creditCardForm.value.holderName,
        creditCardNumber: this.creditCardForm.value.cardNumber.split(" ").join(''),
        expirationDate: expDate + '-' + this.creditCardForm.value.expirationDate.split('/')[0].trim(),
        cardCode: this.creditCardForm.value.cardCode,
      }
      if (this.runPay) {
        data['account_token'] = this.accountToken;
      }
      const [year, month] = data.expirationDate.split('-');
      const formattedDate = `${month}${year.slice(2)}`;
      data.expirationDate = formattedDate;
      let url = `${API_ROUTES.VALORAPI.takePayment}`
      if (this.data.type === 'client') {
        data['clientName'] = this.creditCardForm.value.clientName;
        data['notes'] = this.creditCardForm.value.notes;
        if (this.data?.subNewData) {
          const updatePayload = {
            notes: this.creditCardForm.value.notes,
            email: this.creditCardForm.value.email,
            phoneNumber: this.creditCardForm.value.phoneNumber,
            startDate: moment().format('yyyy-MM-DD'),
            payeeDetails: {
              card_holder_name: this.creditCardForm.value.holderName,
              creditCardNumber: this.creditCardForm.value.cardNumber.split(" ").join(''),
              expirationDate: data.expirationDate,
              cardCode: this.creditCardForm.value.cardCode,
            },
            paymentMethod: 3,
            paymentMode: 1,
            amount: this.data?.subNewData.amount,
            duration: this.data.subNewData.duration,
            packageId: this.data.subNewData.packageId,
            companyId: this.data.subNewData.companyId,
            permissionId: this.data.subNewData.permissionId,
            packageName: this.data.subNewData.packageName,
            addOns: this.data.subNewData.addOns,
            numberOfTrucks: this.data.subNewData.numberOfTrucks,
            subscriptionId: this.data.subNewData.subscriptionId
          }
          if (this.runPay) {
            updatePayload['account_token'] = this.accountToken;
          }
          data = updatePayload;
          url = `${API_ROUTES.CLIENT.createSubscription}`
        }
      }
      this.loader.start();
      this.service.post2(data, url).subscribe(res => {
        this.loader.stop();
        if (res.status) {
          this.toastr.success(res.msg);
          this.close(true);
        } else {
          this.toastr.error(res.msg);
        }
      }, (err: any) => {
        this.toastr.error(err.msg);
      })
    }
  }

  getDuration(data) {
    return showDuration(data)
  }

  setTodecimal(): any {
    if (this.creditCardForm.value.amount) {
      this.creditCardForm.patchValue({ amount: Number(this.creditCardForm.value.amount).toFixed(2) })
    }
  }


  selectedClient(client: any) {

  }
  runner: any;
  accountToken: string = '';
  expiryFromRunner: string = '';
  runPay: boolean = false;
  private isTokenizing = false;
  private tokenizeTimeout: any;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getClientList('');
    })
    if (this.adminProfile?.paymentGateway === 'RUNPAYMENTS') {
      setTimeout(() => {
        this.runner = new Runner();
        this.runner.init({
          element: "#run-form",
          publicKey: "mY4Lk4mXozbxRNh415BZaAZZ",
          cardLabel: 'Card Number',
          cvvLabel: 'CVV',
          useCvv: true,
          useExpiry: true,
          cvvFieldSelector: "#cvvId",
          cardNumberFieldSelector: "#cardNumber-container",
          cardPlaceholder: 'Enter Card Number #',
          cvvPlaceholder: 'Enter CVV #',
          css: `
                * {
                  box-sizing: border-box;
                  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                }

                #cccardlabel, #cccvvlabel, #ccexpirylabel {
                  font-size: 13px !important;
                  font-family: sans-serif;
                  font-weight: 600 !important;
                  color: #444444;
                  margin-bottom: 6px !important;
                  text-transform: uppercase;
                  letter-spacing: 0.04em;
                }

                input {
                  border: none;
                  border-bottom: 1.5px solid #d1d5db;
                  border-radius: 0;
                  font-family: sans-serif;
                  font-weight: 500;
                  font-size: 15px;
                  color: #1d1d1e;
                  padding: 10px 0;
                  width: stretch;
                  background: transparent;
                  margin: 4px 0 16px 0;
                  letter-spacing: 0.12em;
                }

                input::placeholder {
                  color: #c0c0c0;
                  letter-spacing: 0.06em;
                }

                input:focus {
                  outline: none !important;
                  border-bottom-color: #7c3aed;
                }

                select {
                      border: 1px solid #ced4da;
                      border-radius: 10px;
                      font-family: sans-serif;
                      font-weight: 500;
                      font-size: 14px;
                      color: #6b7280;
                      padding: 10px 14px;
                      margin: 4px 0 16px 0;
                      background-color: #fff;
                      appearance: auto;
                      cursor: pointer;
                      min-width: 90px;
                  }

                select:focus {
                  outline: none !important;
                  border-color: #7c3aed;
                }

                iframe {
                  width: strech !important;
                  min-height: 250px !important;
                }
              `
        });

        // Capture token automatically as user fills in card details
        this.runner.onTokenize((res: any) => {
          console.log('Auto tokenized:', res);
          this.isTokenizing = false;

          if (res.hasToken) {
            this.accountToken = res.token;
            const expiry = res.expiration || '';

            if (expiry.length >= 5) {
              const year = expiry.slice(0, 4);
              const month = expiry.slice(4);

              const formattedMonth = month.padStart(2, '0');
              const formattedYear = year.slice(-2);

              this.expiryFromRunner = `${formattedMonth}/${formattedYear}`;
              this.creditCardForm.patchValue({
                expirationDate: this.expiryFromRunner
              })
            } else {
              this.expiryFromRunner = '';
            }
          } else {
            this.accountToken = null; // Reset if tokenization failed
          }
        });

      }, 0);
    }
  }
  check(): void {
    if (this.accountToken) {
      return;
    }

    // Token not yet available — wait briefly for async tokenization to complete
    this.isTokenizing = true;
    clearTimeout(this.tokenizeTimeout);

    this.tokenizeTimeout = setTimeout(() => {
      this.isTokenizing = false;

      if (!this.accountToken) {
        this.toastr.info('Please enter correct card details to proceed.');
      }
    }, 1500); // Wait 1.5s for onTokenize to fire
  }
}
